import { useCallback, useEffect, useState } from "react";
import api from "../../../services/api";
import { fetchOwnerDashboard } from "../services/ownerPatrimonyService";
import { IOwnerData, OwnerPatrimonyRequestStatus } from "../types/ownerDashboard.types";

interface UseOwnerDashboardShellOptions {
  accessToken: string | null;
  enabled: boolean;
  refreshKey: number;
}

interface UseOwnerDashboardShellResult {
  shell: IOwnerData | null;
  status: OwnerPatrimonyRequestStatus;
  reload: () => Promise<void>;
}

export function useOwnerDashboardShell({
  accessToken,
  enabled,
  refreshKey,
}: UseOwnerDashboardShellOptions): UseOwnerDashboardShellResult {
  const [shell, setShell] = useState<IOwnerData | null>(null);
  const [status, setStatus] = useState<OwnerPatrimonyRequestStatus>("idle");

  const reload = useCallback(async () => {
    if (!enabled || !accessToken) {
      return;
    }

    setStatus("loading");

    try {
      api.defaults.headers.authorization = `Bearer ${accessToken}`;
      const response = await fetchOwnerDashboard();
      setShell(response);
      setStatus("success");
    } catch {
      setShell(null);
      setStatus("error");
    }
  }, [accessToken, enabled]);

  useEffect(() => {
    reload();
  }, [reload, refreshKey]);

  return {
    shell,
    status,
    reload,
  };
}
